export enum SWITCH_SIZES {
    Small = "small",
    Medium = "medium",
    Large = "large"
}
